export var Brand;
(function (Brand) {
    Brand["Astrumu"] = "astrumu";
    Brand["AvilaUniversity"] = "avilaUniversity";
    Brand["BakerUniversity"] = "bakerUniversity";
    Brand["KansasUniversity"] = "kansasUniversity";
    Brand["AmericanUniversity"] = "americanUniversity";
    Brand["UniversityOfWashington"] = "universityOfWashington";
    Brand["MissouriKansasCityUniversity"] = "missouriKansasCityUniversity";
    Brand["MetropolitanCommunityCollege"] = "metropolitanCommunityCollegeKansas";
    Brand["MissouriWesternStateUniversity"] = "missouriWesternStateUniversity";
    Brand["UniversityOfCentralMissouri"] = "universityOfCentralMissouri";
})(Brand || (Brand = {}));
export const isDefaultBrand = (brand) => brand === Brand.Astrumu;
//# sourceMappingURL=index.js.map